class Meta {
    portalSiteTitle = 'AuMagic CDM';
    adminSiteTitle = 'AuMagic CDM Admin Console';
    siteDescription = 'AuMagic Customer Data System for our valued customers, with an ease to manage project information flow.';
    childRouteSeparator = ' - ';
}

export default (new Meta());
